/**
 * @file 我的投资信息相关hook
 */
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { PoolButtonType } from '@/types/pool';
import {
  getButtonIsHidden,
  getBtnEmergencyMode,
} from '@/containers/operation/utils';
import { useCurrentChainAddress } from '@/hooks/wallet';

/**
 * @file 控制赎回按钮的一些状态
 */
export const useButtonStatus = () => {
  const { poolInfo } = usePoolInfoContext();
  const { walletAddress } = useCurrentChainAddress(poolInfo.chainCode);
  const unstakeIsDisabled =
    !poolInfo.singleCoins?.length && !poolInfo.multipleCoins?.length;

  const unstakeIsHidden = getButtonIsHidden(
    PoolButtonType.Unstake,
    poolInfo.poolExtendDTO
  );

  const unstakeEmergencyDisabled = getBtnEmergencyMode(
    PoolButtonType.Unstake,
    poolInfo.poolExtendDTO,
    walletAddress
  );

  const delayUnStakeIsHidden = getButtonIsHidden(
    PoolButtonType.DelayUnstake,
    poolInfo.poolExtendDTO
  );

  const delayUnstakeEmergencyDisabled = getBtnEmergencyMode(
    PoolButtonType.DelayUnstake,
    poolInfo.poolExtendDTO,
    walletAddress
  );

  const claimDisabled = getBtnEmergencyMode(
    PoolButtonType.Claim,
    poolInfo.poolExtendDTO,
    walletAddress
  );

  return {
    claimDisabled,
    unstakeEmergencyDisabled,
    delayUnstakeEmergencyDisabled,
    delayUnStakeIsHidden,
    unstakeIsDisabled,
    unstakeIsHidden,
  };
};
